import React, { useEffect, useState } from "react";
import { db } from "../../server";
import Menu from "../../components/Menu";
import { Layout } from "../../Globalstyles/Layout";
import { Container, NoticeListWrapper } from "./styles";
import { FaTrash } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import { deleteNotice } from "../../NoticesFunctions";
import { useNavigate } from "react-router";
import { IsLoged } from "../../App";

export default function NoticeManager() {
	const [noticeList, setNoticeList] = useState([]);
	const [selectedNotice, setSelectedNotice] = useState([]);
	const [modal, setModal] = useState(false);

	const defaultUrlSite = "https://testednaforperformance.netlify.app";

	let navigate = useNavigate();

	const fetchNotices = () => {
		const dbRef = db.collection("noticias");

		dbRef.get().then((snapshot) => {
			if (!snapshot.empty) {
				const notices = snapshot.docs.slice(0, 10).map((doc) => ({
					id: doc.id,
					...doc.data(),
				}));

				setNoticeList(notices);
			} else {
				setNoticeList([]);
			}
			setSelectedNotice([]);
		});
	};
	useEffect(() => {
		if (!IsLoged()) return navigate("/login");
	});
	useEffect(() => {
		fetchNotices();
	}, []);

	console.log(selectedNotice[0]);

	return (
		<div className="app">
			<Layout className="layout">
				<Menu className />
				<Container>
					<div className="action-area">
						<div>
							{selectedNotice.length > 0 && (
								<p>
									<strong>{selectedNotice.length}</strong> notícias selecionadas
								</p>
							)}
						</div>
						<div className={`buttons ${!selectedNotice.length ? "off" : ""}`}>
							<button
								id="delete"
								disabled={!selectedNotice.length}
								onClick={() => {
									if (!selectedNotice.length) {
										alert("precisa selecionar pelo menos 1 notícia!");
									} else {
										setModal(true);
									}
								}}>
								<FaTrash />
							</button>
							<button
								id="edit"
								disabled={!selectedNotice.length}
								onClick={() => {
									if (!selectedNotice.length) {
										alert("Precisa selecionar pelo menos 1 notícia!");
									} else if (selectedNotice.length > 1) {
										alert("Selecione Apenas 1 notícia!");
									} else {
										navigate("editNotice/" + selectedNotice[0]);
									}
								}}>
								<MdEdit />
							</button>
							<div className={modal ? "modalon" : "modalOff"}>
								<h3>
									Certeza que gostaria de deletar a(s) notícia(s):{" "}
									{noticeList
										.filter((n) => selectedNotice.includes(n.id))
										.map((n) => `"${n.title}"`)
										.join(", ")}
									?
								</h3>
								<div className="button-area">
									<button
										style={{ backgroundColor: "var(--light-green)" }}
										onClick={() => {
											setModal(false);
											deleteNotice({
												noticeList: selectedNotice,
												onSuccess: fetchNotices,
											});
										}}>
										Sim
									</button>
									<button
										style={{ backgroundColor: "pink" }}
										onClick={() => {
											setModal(false);
										}}>
										Não
									</button>
								</div>
							</div>
						</div>
					</div>

					<NoticeListWrapper>
						{noticeList.length ? (
							noticeList.map((n) => (
								<li key={n.id}>
									<input
										type="checkbox"
										checked={selectedNotice.includes(n.id)}
										onChange={(e) => {
											if (e.target.checked) {
												setSelectedNotice((prev) => [...prev, n.id]);
											} else {
												setSelectedNotice((prev) =>
													prev.filter((id) => id !== n.id)
												);
											}
										}}
									/>
									<a
										href={`${defaultUrlSite}/blog/notice/${n.id}`}
										target="_blank"
										rel="noreferrer">
										<h3>{n.title}</h3>

										<span>
											{n.edited ? "Ultima edição: " + n.editionDate : " "}
										</span>
									</a>
								</li>
							))
						) : (
							<>
								<p>Nenhuma noticia adicionada ainda...</p>
							</>
						)}
					</NoticeListWrapper>
				</Container>
			</Layout>
		</div>
	);
}
